export type VideoGamecastFitMode = 'cover' | 'contain';

export const DEFAULT_STREAM_ASPECT = 16 / 9;

const MAX_ACCEPTABLE_CROP_FRACTION = 0.15;

export const pickFitMode = (
  viewportWidth: number,
  viewportHeight: number,
  streamAspect: number,
): VideoGamecastFitMode => {
  if (viewportWidth <= 0 || viewportHeight <= 0 || streamAspect <= 0) {
    return 'contain';
  }

  const viewportAspect = viewportWidth / viewportHeight;
  const cropFraction =
    1 -
    Math.min(viewportAspect, streamAspect) /
      Math.max(viewportAspect, streamAspect);

  if (cropFraction <= MAX_ACCEPTABLE_CROP_FRACTION) {
    return 'cover';
  }

  return 'contain';
};

export const useStyles = (
  fitMode: VideoGamecastFitMode,
  streamAspect: number,
) => {
  const isCover = fitMode === 'cover';
  const aspect = streamAspect > 0 ? streamAspect : DEFAULT_STREAM_ASPECT;

  const videoSizing = {
    left: isCover ? '50% !important' : '0 !important',
    top: isCover ? '50% !important' : '0 !important',
    width: isCover
      ? `max(100vw, calc(100vh * ${aspect})) !important`
      : '100% !important',
    height: isCover
      ? `max(100vh, calc(100vw / ${aspect})) !important`
      : '100% !important',
    transform: isCover ? 'translate(-50%, -50%)' : 'none',
    objectFit: isCover ? 'fill' : 'contain',
  };

  return {
    root: {
      position: 'fixed',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      zIndex: -1,
      pointerEvents: 'none',
      overflow: 'hidden',
      '& > #gamecastVideoTag': {
        position: 'absolute !important',
        ...videoSizing,
        pointerEvents: 'auto',
        visibility: 'hidden',
        background: '#000000',
        filter: 'brightness(1)',
      },
    },
  };
};
